// extracted by mini-css-extract-plugin
export default {"quantityModifier":"CartItemQuantityWidget_quantityModifier__09FOH"};